'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIsWidgetInAwayMode = undefined;

var _reselect = require('reselect');

var _widgetIsInAwayMode = require('./widgetIsInAwayMode');

var _getIsInOfficeHours = require('./getIsInOfficeHours');

var getIsWidgetInAwayMode = exports.getIsWidgetInAwayMode = (0, _reselect.createSelector)([_widgetIsInAwayMode.widgetIsInAwayMode, _getIsInOfficeHours.getIsInOfficeHours], function (inAwayMode, isInOfficeHours) {
  return Boolean(inAwayMode || !isInOfficeHours);
});